import { Link } from 'react-router-dom';

export function Services() {
  const services = [
    {
      title: 'Pool Services',
      category: 'Pool',
      icon: 'ri-water-flash-line',
      link: '/services/pool-repair',
      image: 'https://public.readdy.ai/ai/img_res/150d9335497f72a8910d1b7789c5b3b4.jpg',
      services: ['Pool Plaster Repair', 'General Pool Repairs', 'Pool Maintenance', 'Tile & Coping Work', 'Pool Heating Panels']
    },
    {
      title: 'Roofing Services',
      category: 'Roofing',
      icon: 'ri-home-4-line',
      link: '/services/roofing',
      image: 'https://readdy.ai/api/search-image?query=Professional%20roofing%20installation%20on%20beautiful%20residential%20home%2C%20new%20terracotta%20tile%20roof%20in%20Las%20Vegas%20desert%20landscape%2C%20skilled%20roofer%20working%20on%20sloped%20roof%2C%20sunny%20day%20construction%20photography%2C%20high%20quality%20architectural%20roofing%20work&width=800&height=600&seq=service-roofing-card-001&orientation=landscape',
      services: ['Roof Replacement', 'Roof Repair', 'Tile Roofing', 'Flat Roofing', 'Emergency Repairs']
    },
    {
      title: 'Outdoor Living Spaces',
      category: 'Landscaping',
      icon: 'ri-plant-line',
      link: '/services/synthetic-grass',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20backyard%20with%20vibrant%20green%20synthetic%20turf%20grass%20installation%2C%20elegant%20decorative%20paver%20walkway%20and%20patio%20area%2C%20modern%20outdoor%20living%20space%20design%2C%20professional%20landscaping%20hardscape%20work%20with%20pavers%20and%20artificial%20grass%20combination%2C%20natural%20bright%20daylight%2C%20contemporary%20residential%20outdoor%20transformation%2C%20simple%20clean%20background&width=600&height=600&seq=service-outdoor-turf-pavers-002&orientation=squarish',
      services: ['Synthetic Grass Installation', 'Paver Installation', 'Concrete Work', 'Custom Patios']
    },
    {
      title: 'Home Systems',
      category: 'HVAC',
      icon: 'ri-home-gear-line',
      link: '/services/hvac',
      image: 'https://readdy.ai/api/search-image?query=Modern%20HVAC%20air%20conditioning%20unit%20installation%20on%20residential%20home%20exterior%2C%20professional%20heating%20and%20cooling%20system%2C%20clean%20technical%20installation%2C%20bright%20professional%20photography%2C%20quality%20home%20services%20showcase%2C%20simple%20background&width=600&height=600&seq=service-hvac-001&orientation=squarish',
      services: ['A/C Heating & Cooling', 'System Installation', 'Maintenance & Repair', 'Duct Cleaning']
    },
    {
      title: 'Electrical Work',
      category: 'Electrical',
      icon: 'ri-flashlight-line',
      link: null,
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20installing%20modern%20residential%20electrical%20service%20panel%20with%20gray%20metal%20enclosure%20and%20organized%20circuit%20breakers%20in%20rows%2C%20clean%20electrical%20panel%20upgrade%20work%20showing%20proper%20wiring%20connections%20and%20safety%20switches%2C%20contemporary%20home%20electrical%20distribution%20box%20with%20main%20breaker%20and%20neutral%20bus%20bar%20visible%2C%20bright%20indoor%20lighting%20highlighting%20quality%20electrical%20installation%20and%20code%20compliance%20standards%2C%20detailed%20view%20of%20electrical%20panel%20interior%20with%20neatly%20arranged%20breakers%20and%20labeled%20circuits&width=600&height=600&seq=service-electrical-panel-new-version-025&orientation=squarish',
      services: ['Electrical Panel Upgrades', 'Wiring & Rewiring', 'Outlet Installation', 'Lighting Installation', 'Solar Panel Repair']
    },
    {
      title: 'Water Softener Systems',
      category: 'Water Filtration',
      icon: 'ri-filter-3-line',
      link: null,
      image: 'https://readdy.ai/api/search-image?query=Modern%20water%20softener%20filtration%20system%20installation%2C%20clean%20water%20purification%20equipment%2C%20professional%20plumbing%20work%2C%20residential%20water%20treatment%20system%2C%20bright%20clean%20photography%2C%20home%20improvement%20water%20quality%2C%20simple%20white%20background&width=600&height=600&seq=service-water-softener-001&orientation=squarish',
      services: ['Water Softener Installation', 'Filter System Setup', 'Water Quality Testing', 'System Maintenance']
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-start justify-between mb-16 flex-col lg:flex-row gap-6">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
              <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Our Services</span>
            </div>
            <h2 className="text-5xl font-bold text-[#2C2C2C]">Complete Remodeling<br />Solutions</h2>
          </div>
          <div className="max-w-md">
            <p className="text-gray-600 text-base leading-relaxed">
              From pool repairs to roofing and complete outdoor transformations, we provide comprehensive construction and remodeling services for residential and commercial properties throughout Las Vegas.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {services.map((service, index) => {
            const CardContent = (
              <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 h-full">
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={service.image}
                    alt={`${service.title} - Las Vegas remodeling services`}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    title={service.title}
                  />
                  <div className="absolute top-4 left-4 bg-[#FF6B35] text-white px-4 py-1.5 rounded-full text-xs font-semibold">
                    {service.category}
                  </div>
                </div>
                <div className="p-6">
                  <div className="w-12 h-12 bg-[#FF6B35]/10 rounded-full flex items-center justify-center mb-4">
                    <i className={`${service.icon} text-2xl text-[#FF6B35]`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-[#2C2C2C] mb-4">{service.title}</h3>
                  <ul className="grid grid-cols-2 gap-2 mb-6">
                    {service.services.map((s, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-gray-600 text-sm">
                        <div className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full flex-shrink-0"></div>
                        {s}
                      </li>
                    ))}
                  </ul>
                  <div className="flex items-center gap-2 text-[#FF6B35] font-semibold text-sm cursor-pointer hover:gap-3 transition-all">
                    Learn More <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            );

            return service.link ? (
              <Link key={index} to={service.link} className="group cursor-pointer">
                {CardContent}
              </Link>
            ) : (
              <div key={index} className="group cursor-pointer">
                {CardContent}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
